export const LINK_FROM_WEB_CHAT_PARAM = "linkFromWebChatParam";

export const addOpenFromWebChatParam = (url: URL) => {
  url.searchParams.append(LINK_FROM_WEB_CHAT_PARAM, "1");

  return url;
};
